var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1747204348540,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1042,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512-34.13333332a546.13333332 546.13333332 0 1 0 546.13333332 546.13333332A546.13333332 546.13333332 0 0 0 512-34.13333332z m250.31111145 655.58755524a83.74044464 83.74044464 0 0 1-83.51288941 83.51288956H345.20177815A83.74044464 83.74044464 0 0 1 261.68888855 621.4542218v-218.90844372a83.74044464 83.74044464 0 0 1 83.51288941-83.51288956h333.59644389A83.74044464 83.74044464 0 0 1 762.31111145 402.5457782z",
    fill: "#7D9CC2",
    "p-id": 1043
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M703.6017781 369.09511137l-150.41422285 131.29955533a62.80533307 62.80533307 0 0 1-82.3751103 0l-150.4142233-131.29955533a42.09777828 42.09777828 0 0 0-17.06666663 33.45066671v7.28177696l121.05955643 105.35822309-119.01155628 117.41866668a41.87022187 41.87022187 0 0 0 30.0373333 29.12711049l118.32888968-116.73599981a15.01866663 15.01866663 0 0 0 2.73066649-3.86844402 104.2204448 104.2204448 0 0 0 111.50222201 0 15.01866663 15.01866663 0 0 0 2.73066684 3.86844402l118.32888823 116.73599954a41.87022187 41.87022187 0 0 0 30.03733358-29.12711022l-119.01155532-117.41866668 121.05955538-105.35822283v-7.28177722a42.09777828 42.09777828 0 0 0-17.52177726-33.45066619z",
    fill: "#222C37",
    "p-id": 1044
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.071b9d2827e6738169f831ef2947d3fc.svg";
export { ForwardRef as ReactComponent };